import axios from 'axios';
import { CMError } from "./cm-error.model";
import Vue from "vue";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.CfpAPI)
            this.$cfpApi = options.CfpAPI;
        else if (options.parent && options.parent.$cfpApi)
            this.$cfpApi = options.parent.$cfpApi;
    }
});

export function makeCfpAPI(token, conf) {
    return new CfpAPI(token, conf);
}

export default class CfpAPI {

    constructor(token) {
        this._ax = axios.create({
            baseURL: process.env.VUE_APP_CFP_API_ENDPOINT,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        });
    }

    async getUserProposals(payload) {
        try {
            const papers = await this._ax.post('proposals', payload);
            return papers.data.data.proposals;
        } catch (error) {
            this._handleError(error);
        }
    }

    async getInvitations() {
        try {
            const papers = await this._ax.get('proposal/invitations');
            return papers.data.data.proposals;
        } catch (error) {
            this._handleError(error);
        }
    }

    // async getPapersByEventId(id, page, perPage, states) {
    //     try {
    //         const papers = await this._ax.post('admin/proposal/event/' + id, {
    //             page: page,
    //             per_page: perPage,
    //             filters: {
    //                 state: states
    //             }
    //         });
    //         return papers.data.data.proposals;
    //     } catch (error) {
    //         this._handleError(error);
    //     }
    // }

    async updateProposal(id, payload) {
        try {
            await this._ax.put('proposal/' + id, payload)
        } catch (error) {
            this._handleError(error);
        }
    }

    // async updatePaperState(id, state) {
    //     try {
    //         await this._ax.put('admin/proposal/' + id + '/state', { state: state })
    //     } catch (error) {
    //         this._handleError(error);
    //     }
    // }

    async getCfpByEventId(id) {
        try {
            const cfp = await this._ax.get('cfp/event/' + id);
            return cfp.data.data.cfp;
        } catch (error) {
            this._handleError(error);
        }
    }

    async getCfpFields() {
        try {
            const fields = await this._ax.get('cfp/options')
            return fields.data
        } catch (error) {
            this._handleError(error)
        }
    }

    async getCfpBySlug(slug) {
        try {
            const cfp = await this._ax.get('cfp/slug/' + slug);
            return cfp.data.data.cfp;
        } catch (error) {
            this._handleError(error);
        }
    }

    async insertProposal(payload) {
        try {
            await this._ax.post('proposal', payload);
            return true;
        } catch (error) {
            this._handleError(error);
        }
    }

    _handleError(error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new CMError('Unauthorized', error);
            }
            if (error.response.status === 409) {
                throw new CMError('Conflict', "There is another event with the same data");
            }
            throw new CMError("GenericError", error.response)
        } else if (error.request) {
            throw new Error('Error on request => Server does not respond');
        } else {
            throw new Error('Client error => ' + error.message);
        }
    }
}